import { SoaFrameworkPanel } from "../components/SoaFrameworkPanel";
import { StandardHeader, STANDARD_PAGE_LABELS } from "../components/standards/StandardHeader";

export function Iso9001SoaPage() {
  return (
    <div className="page-pad">
      <StandardHeader
        frameworkId="iso9001"
        page={STANDARD_PAGE_LABELS.soa}
        subtitle="Decide which quality management controls apply to your organisation, record why, and attach evidence."
      />
      <SoaFrameworkPanel frameworkId="iso9001" />
    </div>
  );
}
